/* tslint:disable */

declare var Object: any;
export interface SfCareerInterface {
  "id"?: number;
}

export class SfCareer implements SfCareerInterface {
  "id": number;
  constructor(data?: SfCareerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SfCareer`.
   */
  public static getModelName() {
    return "SfCareer";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SfCareer for dynamic purposes.
  **/
  public static factory(data: SfCareerInterface): SfCareer{
    return new SfCareer(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SfCareer',
      plural: 'sfCareer',
      path: 'sfCareer',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SfCareer.ts